import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import Cross from '../../../webcommon/common/Icons/Cross.svg';
import { noop } from 'lodash';
import ActionButton from '../../../webcommon/common/actionbutton/ActionButton';
import defaultStyles from './ConfirmDelete.module.scss';

const ConfirmDelete = (props) => {
    const { confirmDeleteMapping, closeModal, idOfRowToDelete } = props;

    const deleteMapping = useCallback(() => {
        closeModal();
        confirmDeleteMapping(idOfRowToDelete);
    }, [confirmDeleteMapping, closeModal, idOfRowToDelete]);

    return (
        <div className={ props.styles.confirmDeleteRowWrapper }>
            <div className={ props.styles.deleteRowHeader }>
                { props.deleteMessage }
                <button
                    type="button"
                    className={ props.styles.mappingHeaderCloseButton }
                    onClick={ props.closeModal }
                >
                    <img
                        alt="Cross"
                        src={ Cross }
                        className={ props.styles.svg }
                    />
                </button>
            </div>

            <div className={ props.styles.deleteRowButtons }>
                <div className={ props.styles.confirmDeleteButton }>
                    <ActionButton
                        accent
                        onClick={ deleteMapping }
                    >
                        Yes
                    </ActionButton>
                </div>
                <div className={ props.styles.cancelDeleteButton }>
                    <ActionButton
                        onClick={ props.closeModal }
                    >
                        No
                    </ActionButton>
                </div>
            </div>
        </div>
    );
};

ConfirmDelete.propTypes = {
    closeModal: PropTypes.func,
    confirmDeleteMapping: PropTypes.func,
    idOfRowToDelete: PropTypes.string,
    styles: PropTypes.objectOf(PropTypes.string),
    deleteMessage: PropTypes.string
};

ConfirmDelete.defaultProps = {
    closeModal: noop,
    confirmDeleteMapping: noop,
    idOfRowToDelete: '',
    styles: defaultStyles,
    deleteMessage: 'Are you sure you want to delete this mapping?'
};

export default ConfirmDelete;
